import Phaser from "phaser";

type Tilemap = Phaser.Tilemaps.Tilemap;
type Shape = Phaser.GameObjects.Shape;

export default class FurnitureProvider {

    furnitureCollection:FurnitureInstance[] = []
    preload(scene:Phaser.Scene): void {
        scene.load.image('couch_brown', '/assets/maps/features/furniture/couch_brown.png');
        scene.load.image('couch_green', '/assets/maps/features/furniture/couch_green.png');
        scene.load.image('dice', '/assets/maps/features/furniture/dice.png');
        scene.load.image('piano', '/assets/maps/features/furniture/piano.png');
    }

    processMapFeatures(map: Tilemap, layer: string, scene:Phaser.Scene) {
        const group = scene.physics.add.staticGroup()

        const furnishings = map.filterObjects(layer, (obj) => {
            return obj.type === "Furnishing"
        })//[0] as Shape

        furnishings.forEach((f) => {
            const shape = f as Shape
            let h = group.create(shape.x, shape.y, shape.name) as any
            h.x = h.x - (h.width * 2)
            h.y = h.y + (h.height + 2)
            let rotation = findMapInt(shape, "rotate");
            if(rotation){
                console.log("rotation", rotation)
                console.log("h", h)
                h.angle = rotation
            }
            /*const dval = shape.properties("rotate")
            if(dval)
            {
                console.log("dval", dval)
                console.log("h", h)
            }*/
        })
    }

}

function findMapInt(shape:Shape, key:string):number | null{
    const s = shape as any
    let retval: number | null = null
    if(s.properties) {
        s.properties.forEach((p: any) => {
            console.log("prop", p)
            if (p.name === key) {
                retval = p.value as number
            }
        })
    }

    return retval
}

export class FurnitureInstance {

}
